import React from 'react';
import { useEffect, useState } from 'react';
import { useDeviceInfo, useDispatch, useI18n, useLogger, useSelector } from '~Hooks';

import { MethodProps } from '../types';
import { useStorage } from '~/Components/Storage';
import TipPicker from '~Components/TipPicker';

const IZettleHandyPayment: React.FunctionComponent<MethodProps> = ({
  payment,
  orderAmount,
  discount,
  order,
  amount,
  onMetaChange,
  onComplete,
  onFail,
}) => {
  const { i18n } = useI18n();
  const [tipAmount, setTipAmount] = useState<number | null>(null);
  const logger = useLogger('zettle');
  const [storage] = useStorage();
  const dispatch = useDispatch();
  const request = useSelector((state) =>
    state.paymentBridgeRequests.find((req) => req.paymentId === payment.id),
  );
  const deviceInfo = useDeviceInfo();

  function handleTipChange(tip: number) {
    setTipAmount(tip);
    logger.info('Zettle Tips: ' + tip);
    onMetaChange({
      tip: tip,
    });
  }

  /*
   * This effect sends off the initial payment request
   */
  useEffect(() => {
    // Dont try to make a payment if its not valid
    if (!amount || amount < 10) {
      return;
    }

    if (storage.enableTipping && tipAmount === null) {
      return;
    }

    logger.info(
      'Zettle handy: Initiating payment. Amount: ' +
        amount +
        ' Order total: ' +
        (orderAmount - discount).toString(),
      order,
    );

    dispatch({
      type: 'PAYMENT_BRIDGE_REQUEST',
      id: payment.id,
      amount: amount + (tipAmount || 0),
      enableTipping: false,
      method: 'IZETTLE',
    });
  }, [tipAmount]);

  /*
   * This effect manages payment status after it has been initiated
   */
  useEffect(() => {
    if (amount === 0) {
      onComplete();
    }

    if (!request) {
      return;
    }

    if (request.status === 'SUCCESS') {
      logger.info('Zettle: Payment successful');

      onComplete(null, {
        tip: tipAmount || 0,
        cardDetails: request.cardDetails,
      });
    }

    if (request.error) {
      onFail(request.error);
    }
  }, [request]);

  return storage.enableTipping ? (
    <TipPicker
      paymentAmount={amount!}
      title={i18n('Handy.Payment.SelectTip')}
      onSubmit={handleTipChange}
    />
  ) : null;
};

export default IZettleHandyPayment;
